var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Grid, List, ListItem, Typography } from "@mui/material";
import sidepanelImg from "../../../images/contract-sidepanel.png";
import logo from "../../../images/eurosafe_logo.png";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import ContractApi from "../../../infrastructure/api/pages/contract-api";
const ContractSidePanel = () => {
    const defaultUserData = {
        id: "",
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        password: "",
        isDeleted: false,
        locale: "",
        roles: [],
    };
    const { t: translate } = useTranslation();
    const urlParams = new URLSearchParams(window.location.search);
    const contractId = urlParams.get("contractId");
    const [responsiblePerson, setResponsiblePerson] = useState();
    useEffect(() => {
        getData();
    }, [contractId]);
    const getData = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            if (contractId) {
                yield ContractApi.getResponsiblePersonByContractId(contractId).then((response) => {
                    setResponsiblePerson(response.data);
                });
            }
        }
        catch (error) {
            console.error("Error while fetching responsible persons:", error);
        }
    });
    return (_jsx(Grid, { className: "sidepanel", size: {
            xs: 12,
            md: 3.8,
            lg: 3.8
        }, sx: {
            alignItems: "center",
            justifyContent: "center",
            p: { xs: 0.5, sm: 1, md: 2 },
            gap: 2
        }, children: _jsxs(Box, { sx: {
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                height: "100%",
                gap: 5,
            }, children: [_jsxs(Grid, { className: "uppersidepanel", size: 12, children: [_jsx(Grid, { size: 12, children: _jsx(Box, { component: "img", sx: {
                                    width: { xs: "96%", sm: "100%" },
                                    borderRadius: "24px  24px 0px  0px",
                                }, src: sidepanelImg }) }), _jsxs(Grid, { className: "textcontainer", size: 12, sx: {
                                padding: 4
                            }, children: [_jsx(Typography, { className: "sidepanelheading", children: translate("What can you expect from us?") }), _jsxs(List, { sx: { listStyleType: "disc", lineHeight: "0.15", paddingLeft: 2 }, children: [_jsx(ListItem, { sx: { display: "list-item" }, className: "sidepanellisttext", children: translate("ContractSidePanelPointer1") }), _jsx(ListItem, { sx: { display: "list-item" }, className: "sidepanellisttext", children: translate("ContractSidePanelPointer2") }), _jsx(ListItem, { sx: { display: "list-item" }, className: "sidepanellisttext", children: translate("ContractSidePanelPointer3") }), _jsx(ListItem, { sx: { display: "list-item" }, className: "sidepanellisttext", children: translate("ContractSidePanelPointer4") }), _jsx(ListItem, { sx: { display: "list-item" }, className: "sidepanellisttext", children: translate("ContractSidePanelPointer5") }), _jsx(ListItem, { sx: { display: "list-item" }, className: "sidepanellisttext", children: translate("ContractSidePanelPointer6") }), _jsx(ListItem, { sx: { display: "list-item" }, className: "sidepanellisttext", children: translate("ContractSidePanelPointer7") }), _jsx(ListItem, { sx: { display: "list-item" }, className: "sidepanellisttext", children: translate("ContractSidePanelPointer8") })] })] }), _jsx(Grid, { className: "textcontainer", size: 12, sx: {
                                padding: 4
                            }, children: _jsx(Typography, { className: "sidepanellisttext", children: translate("ContractSidePanelPointerFooter") }) })] }), _jsxs(Grid, { container: true, className: "buttomsidepanel", size: 12, sx: {
                        borderRadius: "24px"
                    }, children: [_jsx(Grid, { size: 6, sx: {
                                paddingLeft: 1,
                                paddingTop: 2,
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                background: "#F9F6FF",
                                borderRadius: "24px 0px 0px 24px"
                            }, children: _jsx(Typography, { className: "buttomheading", children: translate("I am here for you") }) }), _jsx(Grid, { sx: {
                                display: "flex",
                                background: "#F9F6FF",
                                borderRadius: "0px 24px 24px 0px",
                                justifyContent: "flex-end",
                            }, size: 6, children: _jsx(Box, { component: "img", src: logo, sx: {
                                    width: "100%",
                                    height: "auto",
                                    maxWidth: "100%",
                                    borderRadius: "inherit",
                                    objectFit: "contain", // or "contain" depending on how you want the image to fit
                                } }) })] })] }) }));
};
export default ContractSidePanel;
